import * as e from "react";
const t = (a) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ e.createElement("g", { clipPath: "url(#icon-shield-lock_svg__clip0_655_34200)", fill: "#fff" }, /* @__PURE__ */ e.createElement("path", { d: "M12 13.49a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM12 4.74a1.76 1.76 0 00-1.75 1.75v1.25a.5.5 0 00.5.5h2.5a.5.5 0 00.5-.5V6.49A1.76 1.76 0 0012 4.74z" }), /* @__PURE__ */ e.createElement("path", { d: "M24 2a2 2 0 00-2-2H2a2 2 0 00-2 2v7.31A15.13 15.13 0 0011.86 24c.066.01.134.01.2 0 .066.01.134.01.2 0A15.14 15.14 0 0024 9.2V2zm-7 12.74a1 1 0 01-1 1H8a1 1 0 01-1-1v-5.5a1 1 0 011-1h.25a.5.5 0 00.5-.5V6.49a3.25 3.25 0 016.5 0v1.25a.5.5 0 00.5.5H16a1 1 0 011 1v5.5z" })),
  /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "icon-shield-lock_svg__clip0_655_34200" }, /* @__PURE__ */ e.createElement("path", { d: "M0 0h24v24H0z" })))
);
export {
  t as default
};
